<div class="loading-container">
    <img src="../../../assets/images/plane-loading-50x50.gif" alt="Loading">
</div>